function popup () {
    /*
    Основные настройки попапа
    */
    const popup = document.querySelector('.popup');
    const showPopup = document.querySelectorAll('.popup-show');
    const closePopup = document.querySelectorAll('.popup-close');

    if(popup) {
        showPopup.forEach(el=> {
            el.addEventListener('click', (e)=> {
                e.preventDefault();
                popup.classList.add('show');
                document.body.style.overflow = 'hidden';
            });
        });

        closePopup.forEach(el=> {
            el.addEventListener('click', (e)=> {
                e.preventDefault();
                popup.classList.remove('show');
                document.body.style.overflow = 'initial';
            });
        });

        document.body.addEventListener('click', function(e) {
            if(e.target && e.target.classList.contains('popup')) {
                popup.classList.remove('show');
                document.body.style.overflow = 'initial';
            }
        });
    }

    /*
    Настройки попапа при взаимодействии с брендами на странице каталога
    */
    const aboutBrandTitle = document.querySelectorAll('.catalog__brand-info');

    if(aboutBrandTitle.length > 0) {
        aboutBrandTitle.forEach(el=> {
            el.addEventListener('click', function(e) {
                e.preventDefault();
                //Находим родителя
                const parent = this.closest('.catalog__item');
                //Получаем значение дата-атрибута бренда, по которому кликнули
                const targetBrand = parent.dataset.brand.toLowerCase();
    
                
                //Находим в попапе контейнер с таким же дата
                const aboutBrandContainer = document.querySelectorAll('.catalog__about-brand-txt');

                aboutBrandContainer.forEach(el=> {
                    //Прячем описания всех брендов
                    el.classList.remove('show');
    
                    //Меняем на строчные символы в названии брендов
                    el.dataset.brand = el.dataset.brand.toLowerCase();
    
                    //Показываем только тот бренд, который относится к выбранному
                    if(el.dataset.brand === targetBrand) {
                        el.classList.add('show');
                    }
                });
            });
        })
    }


    /**
     * Welcome popup
     */
    const welcome = document.querySelector('.welcome');

    if (welcome) {
        // Проверка наличия класса hide при загрузке страницы
        // if (localStorage.getItem('welcomeHidden') === 'true') {
        //     welcome.classList.add('hide');
        // }

        const closeBtn = document.querySelector('.welcome__close');

        closeBtn.addEventListener('click', () => {
            welcome.classList.add('hide');
            // localStorage.setItem('welcomeHidden', 'true'); // Сохранение состояния в localStorage
        });

        document.addEventListener('click', (e) => {
            if (e.target && e.target.classList.contains('welcome')) {
                welcome.classList.add('hide');
                // localStorage.setItem('welcomeHidden', 'true'); // Сохранение состояния в localStorage
            }
        });
    }
}

export default popup;